<template>
<div  v-loading="loading" element-loading-text="数据导出中">
   <ageList v-on:ageListEvent="ageListEvent" />
  <div class="op">
    <Candode v-on:childByValue="childByValue" v-on:getTownlength="getTownlength" :address="address"></Candode>
<div class="nam">
  <el-input v-model="name" style="margin-left:10px" clearable size="mini" placeholder="请输入姓名"></el-input>
</div>
  <div class="idc">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
 <div class="add">
  <el-select size="mini" @change="torz" v-model="state" placeholder="认证状态">
    <el-option
      v-for="(item3,index) in stateList"
      :key="index"
      :label="item3.label"
      :value="item3.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-date-picker
      v-model="time"
      size='mini'
      type="daterange"
      range-separator="至"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div>
</div>
<div class="op" style="margin-top:10px">
   <div class="add"  style="margin-left:0">
  <el-select size="mini" @change="torz"  v-model="cblx" placeholder="参保类型">
    <el-option
      v-for="(item6,index) in cblxList"
      :key="index"
      :label="item6.label"
      :value="item6.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-select size="mini" @change="torz" clearable v-model="age" placeholder="选择年龄">
    <el-option
      v-for="(item4,index) in ageList"
      :key="index"
      :label="item4.label"
      :value="item4.value">
    </el-option>
  </el-select>
</div>
<!--<div class="add">
    <el-select size="mini" @change="torz" clearable v-model="agemeth" placeholder="年龄计算方式">
    <el-option
      v-for="item5 in agemethList"
      :key="item5.value"
      :label="item5.label"
      :value="item5.value">
    </el-option>
  </el-select>
</div>-->
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
</div>
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
      <el-table-column
      label="身份证号"
      width="180">
      <template slot-scope="scope">
      <span style="color:#27ADF8;cursor:pointer;border-bottom:1px solid #27ADF8" @click="toOwm(scope.row.identityNumber)"> {{ scope.row.identityNumber }}</span>
      </template>
    </el-table-column>

    <el-table-column
      prop="personName"
      label="姓名"
      width="100">
    </el-table-column>
     <el-table-column
      prop="telphone"
       width="110"
      label="手机号">
    </el-table-column>
      <el-table-column
      prop="verify_types"
       width="180"
      label="补贴类型">
    </el-table-column>
    <el-table-column
      prop="match_state"
      label="认证状态">
    </el-table-column>
    <el-table-column
          prop="townName"
          label="镇">
        </el-table-column>
    <el-table-column
              prop="villageName"
              label="村">
            </el-table-column>
    <el-table-column
        prop="groupName"
        label="组">
      </el-table-column>
     <el-table-column
      prop="nowAddress"
      label="认证地点">
    </el-table-column>
     <el-table-column
      prop="createTime"
      label="认证时间">
    </el-table-column>
     <el-table-column
      prop="createtime"
      label="认证照片">
      <template slot-scope="scope">
        <el-popover
    placement="left"
    title=""
    trigger="hover">
                    <img slot="reference" :src="(scope.row.recordPhoto?(imgUrl+scope.row.recordPhoto):'')||defaultImg" height="70"  class="head_pic">
                    <img :src="(scope.row.recordPhoto?(imgUrl+scope.row.recordPhoto):'')||defaultImg"  height="200px"  class="head_pic"/>
                    </el-popover>
                </template>
    </el-table-column>

  </el-table>
  <div class="rrr">
  <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
    <!-- <el-button type="success" size="mini" icon="el-icon-download" @click="toExcel()">导出</el-button> -->
     <kt-button class="changeBasic" icon="fa el-icon-download" label="导出" perms="auth:menu:down" type="primary" @click="toExcel" />
    </div>
  </div>
</template>

<style scoped>
.rrr {
  display: flex;
  margin: 20px;
  height: 30px;
  justify-content: space-around;
  align-items: center;
}
.pone {
  margin: 0 !important;
}
.el-cascader-menu__wrap {
  height: 404px !important;
}
.op {
  display: flex;
  align-items: center;
}
.idc {
  width: 200px;
}
.nam {
  margin-right: 20px;
}
.ywtyoe {
  width: 200px;
  margin-left: 20px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-timeline {
  padding-left: 20px;
}
.add {
  margin-left: 20px;
}
</style>

<script>
import Axios from "axios";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { Loading } from "element-ui";
import { listtown } from "../../utils/address";
import { baseUrl2 } from "../../utils/global";
import defaultImg from "../../assets/defaultPicture.jpg";
import Candode from "../Core/candode";
import { decryptByDES, decrypt } from "../../utils/cypto";
import { formatDate } from "../../utils/datetime";
import { getType } from "../../utils/typeAuth";
import baseUrl from "../../utils/global";
import KtButton from "@/views/Core/KtButton";
import { fromModel } from "../../utils/fromModel";
import ageList from "../../utils/ageList.vue";
import getNowMonth from "../../utils/getNowMonth";
export default {
  components: {
    Candode,
    KtButton,
    ageList
  },
  data() {
    return {
      address: [],
      loading: false,
      list: [],
      name: "",
      town: "",
      village: "",
      defaultImg: defaultImg,
      townList: [],
      imgUrl: "http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
      Page: 1,
      totals: 0,
      idcard: "",
      info: "",
      ywtype: "",
      tableData: [],
      list2: [],
      //认证状态
      state: "0",
      stateList: [
        {
          value: "0",
          label: "认证成功"
        },
        {
          value: "2",
          label: "认证失败"
        },
        {
          value: "5",
          label: "未认证"
        },
        {
          value: "3",
          label: "审核中"
        }
      ],
      //时间
      time: "",
      //年龄
      age: "",
      ageList: ageList,
      //年龄计算方式
      agemeth: "1",
      agemethList: [
        {
          value: "1",
          label: "按年计算"
        },
        {
          value: "2",
          label: "按月计算"
        }
      ],
      //参保类型
      cblx: "",
      cblxList: [],
      townlen: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: "1月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 0, 1);
              const end = new Date(year, 1, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "2月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 1, 1);
              const end = new Date(year, 2, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 2, 1);
              const end = new Date(year, 3, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "4月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 3, 1);
              const end = new Date(year, 4, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "5月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 4, 1);
              const end = new Date(year, 5, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 5, 1);
              const end = new Date(year, 6, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "7月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 6, 1);
              const end = new Date(year, 7, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "8月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 7, 1);
              const end = new Date(year, 8, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "9月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 8, 1);
              const end = new Date(year, 9, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "10月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 9, 1);
              const end = new Date(year, 10, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "11月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 10, 1);
              const end = new Date(year, 11, 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "12月",
            onClick(picker) {
              const year = new Date().getFullYear();
              const start = new Date(year, 11, 1);
              const end = new Date(year, 12, 0);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    toOwm(s) {
      this.$router.push({
        name: "个人信息",
        params: {
          idcard: s
        }
      });
    },
    fromModel: fromModel,
    ageListEvent(s) {
      this.ageList = s;
    },
    strReplace(msg) {
      let str = getType(msg);
      return str;
    },
    formatDate: formatDate,
    childByValue(val, nm, flag) {
      if (flag) {
        if (this.townList.length == 0) {
          this.townList = val;
        } else {
          this.address = this.townList.slice(nm, this.townList.length);
        }
      } else {
        this.townList = val;
        //this.address=this.townList.slice(nm-1,this.townList.length-1)
      }
    },
    getTownlength(val) {
      this.townlen = val;
    },
    //搜索
    serch() {
      const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      if (!isTown) {
        this.$message({
          type: "warning",
          message: "请选择县/区及以下区域进行操作"
        });
        return;
      }
      this.serchTest(1);
    },
    serchCode() {
      let data = {
        pageNum: 1,
        pageSize: 10,
        personName: this.name ? this.Encrypt(this.name) : "",
        province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
        city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
        county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
        town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
        village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        verify_type: this.cblx
      };
      this.$api.getlist
        .findVerifyPage(data)
        .then(res => {
          let result = res.data.list;
          this.totals = res.data.total;
          for (var i in result) {
            result[i].identityNumber = this.decrypt(result[i].identityNumber);
            result[i].personName = this.decrypt(result[i].personName);
            result[i].telphone = result[i].telphone
              ? this.decrypt(result[i].telphone)
              : "";
            //result[i].createTime=result[i].createTime?this.formatDate(result[i].createTime):""
            result[i].verify_types = result[i].verify_types
              ? this.strReplace(result[i].verify_types)
              : "";
            result[i].match_state =
              result[i].match_state == 0
                ? "认证成功"
                : result[i].match_state == 1
                  ? "认证未完成"
                  : result[i].match_state == 2
                    ? "认证失败"
                    : result[i].match_state == 3
                      ? "审核中"
                      : result[i].match_state == 4
                        ? "停止发放"
                        : result[i].match_state == 5
                          ? "已死亡"
                          : "";
          }
          this.tableData = result;
          sessionStorage.setItem("datase", JSON.stringify(this.$data));
        })
        .catch(res => {
          this.$message(JSON.stringify(res));
        });
    },
    toExcel() {
      // const isTown = this.townList[2] ? this.townList[2].split(",")[0] : "";
      // if (!isTown) {
      //   this.$message({
      //     type: "warning",
      //     message: "请选择县/区及以下区域进行操作"
      //   });
      //   return;
      // }
      this.loading = true;
      let data = {
        addressRelation: sessionStorage.getItem("user"),
        personName: this.name ? this.Encrypt(this.name) : "",
        province_name: this.townList[0] ? this.townList[0].split(",")[0] : "",
        city_name: this.townList[1] ? this.townList[1].split(",")[0] : "",
        county_name: this.townList[2] ? this.townList[2].split(",")[0] : "",
        town_name: this.townList[3] ? this.townList[3].split(",")[0] : "",
        village_name: this.townList[4] ? this.townList[4].split(",")[0] : "",
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        match_state: this.state,
        verify_type: this.cblx,
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
        quarry_rule: this.agemeth
      };
      this.$api.getlist
        .authData(data)
        .then(res => {
          var that = this;
          if (res.code == 200) {
            this.loading = false;
            window.location.href =
              baseUrl.baseUrl + "/download/excel?fileName=" + res.result;
          } else {
            this.loading = false;
            this.$message(res.describe);
          }
        })
        .catch(res => {
          this.$message("导出失败");
          this.loading = false;
        });
    },
    serchTest(s) {
      Loading.service();

      var data = {
        pageNum: s,
        pageSize: 10,
        personName: this.name ? this.Encrypt(this.name) : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        town: this.townList[3] ? this.townList[3].split(",")[1] : "",
        groupName: this.townList[5] ? this.townList[5].split(",")[1] : "",
        village: this.townList[4] ? this.townList[4].split(",")[1] : "",
        birthday: this.age,
        identityNumber: this.idcard ? this.Encrypt(this.idcard) : "",
        match_state: this.state,
        verify_type: this.cblx,
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
        quarry_rule: this.agemeth
      };
      this.$api.getlist
        .findVerifyPage(data)
        .then(res => {
          let result = res.data.list;
          this.totals = res.data.total;
          for (var i in result) {
            result[i].identityNumber = this.decrypt(result[i].identityNumber);
            result[i].personName = this.decrypt(result[i].personName);
            result[i].telphone = result[i].telphone
              ? this.decrypt(result[i].telphone)
              : "";
            // result[i].createTime=result[i].createTime?this.formatDate(result[i].createTime):""
            result[i].verify_types = result[i].verify_types
              ? this.strReplace(result[i].verify_types)
              : "";
            result[i].match_state =
              result[i].match_state == 0
                ? "认证成功"
                : result[i].match_state == 1
                  ? "认证未完成"
                  : result[i].match_state == 2
                    ? "认证失败"
                    : result[i].match_state == 3
                      ? "审核中"
                      : result[i].match_state == 4
                        ? "停止发放"
                        : result[i].match_state == 5
                          ? "已死亡"
                          : "";
          }
          this.tableData = result;
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading需要异步关闭
            loadingInstance.close();
          });
          sessionStorage.setItem("datase", JSON.stringify(this.$data));
        })
        .catch(err => {
          let loadingInstance = Loading.service();
          this.$nextTick(() => {
            //以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
    },
    current_change(ss) {
      this.serchTest(ss);
    },
    handleChange() {},
    torz() {},
    //查看
    handle(s, d) {},
    handleDelete(g, h) {
      console.log(g);
      console.log(h);
    },
    Encrypt(word) {
      //aes加密
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    decrypt(word) {
      var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypt = CryptoJS.AES.decrypt(word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },
    decryptDes(message) {
      var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
      var decrypted = CryptoJS.DES.decrypt(
        {
          ciphertext: CryptoJS.enc.Hex.parse(message)
        },
        keyHex,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      );
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },
  mounted() {},
  created() {
    if (sessionStorage.getItem("datase")) {
      Object.assign(this.$data, JSON.parse(sessionStorage.getItem("datase")));
      this.ywtype = "";
      this.options1 = [];
      this.multipleSelection = [];
      this.flag = true;
    }
    let city = JSON.parse(sessionStorage.getItem("list")).city;
    if (city) {
      if (city.split(",")[1] == "潍坊市") {
        this.time = getNowMonth();
      } else {
        this.time = "";
      }
    }
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
      arr.unshift("");
    }

    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Myvue/authSelet.vue